module.exports = __webpack_public_path__ + "img/charging-station-infographic-mobile@2x.3eff7631.webp";